import React from 'react';
import {Box, IconButton} from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {useTheme} from '@mui/material/styles';


function SortableItem({id, children, onContextMenu}) {
    const theme = useTheme();

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({id, handle: true});

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    };

    return (
        <Box
            ref={setNodeRef}
            style={style}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0,
                width: '100%',
                mb: 0,
                color: theme.palette.text.primary
            }}
        >
            {!id.startsWith('__') && (
                <IconButton
                    {...attributes}
                    {...listeners}
                    size="small"
                    onContextMenu={(e) => {
                        if (onContextMenu) onContextMenu(e);
                    }}
                    sx={{
                        cursor: 'move',
                        p: 0,
                        color: 'theme.palette.text.secondary',
                    }}
                >
                    <DragIndicatorIcon fontSize="small"/>
                </IconButton>
            )}
            <Box flex={1}>{children}</Box>
        </Box>
    );
}

export default SortableItem;
